import styled from "@emotion/styled";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";
import { getInputFieldHeightValue, InputFieldBaseProps } from "../../../../util/inputFieldBaseProps";
import { formInputTheme } from "../../../textinput/styled/formInputTheme";
import { TypeRampV2 } from "../../../typography";
import { selectV2Theme } from "../selectV2Theme";

interface SelectPlaceholderStyledProps extends InputFieldBaseProps {
    hasContentBefore: boolean;
    themeMode: RequiredThemeKeys;
}

export const SelectPlaceholderStyled = styled(TypeRampV2)<SelectPlaceholderStyledProps>`
    color: ${({ themeMode }) =>
        `var(--sds--form--color--placeholder, ${formInputTheme.placeholderColor.hover(themeMode)})`};

    position: absolute;
    top: ${({ themeMode, inputFieldHeight }) =>
        formInputTheme.placeholderTop[getInputFieldHeightValue(themeMode, inputFieldHeight)](themeMode)};
    margin-top: auto;
    margin-bottom: auto;
    left: ${({ hasContentBefore, themeMode }) =>
        hasContentBefore
            ? selectV2Theme.input.padding.placeholder(themeMode)
            : selectV2Theme.input.padding.left(themeMode)};

    user-select: none;
    right: 30px;
    text-align: left;
    pointer-events: none;
`;
